export default __webpack_public_path__ + "static/media/property_293.9621eae4.png";